<template>
  <div>

    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-bar-chart"></i> {{ $t('dashboard.member.title') }}

        <div class="float-right" >
          <a href="#filter" name="filter" v-on:click="expandOrCollapseFilter">
              <span class="fa fa-expand fa-lg" v-if="!filterVisible" ></span>
              <span class="fa fa-compress fa-lg" v-if="filterVisible"></span>
          </a>
        </div>
      </div>
      <div class="card-body" v-if="filterVisible">
        
        <div class="row">

          <div class="form-group col-md-4">
            <label for="memberType">{{ $t('member.form.type') }}</label>
            <multiselect v-model="filter.type" track-by="key" label="value"
              :options="memberTypes" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('member.form.type')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-4">
            <label for="memberStatus">{{ $t('member.form.status') }}</label>
            <multiselect v-model="filter.status" track-by="key" label="value"
              :options="memberStatus" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('member.form.status')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>


          <div class="form-group col-md-4">
            <label for="sex">{{ $t('member.form.sex') }}</label>
            <multiselect v-model="filter.sex" track-by="item1" label="item2"
              :options="sexes" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('member.form.sex')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="regionInput">{{ $t('address.form.region') }}</label>
            <multiselect v-model="filter.region" track-by="item1" label="item2"
              :options="regions" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('address.form.region')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-2"> 
              <label for="memberSince">{{ $t('dashboard.member.form.dateFrom') }}</label>
              <moment-date-picker v-model="filter.dateFrom" :required="false"></moment-date-picker>
          </div>
          <div class="form-group col-md-2"> 
              <label for="memberSince">{{ $t('dashboard.member.form.dateTo') }}</label>
              <moment-date-picker v-model="filter.dateTo" :required="false"></moment-date-picker>
          </div>

          <div class="form-group col-md-2"> 
              <label for="memberSince">{{ $t('dashboard.member.form.memberSinceFrom') }}</label>
              <moment-date-picker v-model="filter.memberSinceFrom" :required="false"></moment-date-picker>
          </div>
          <div class="form-group col-md-2"> 
              <label for="memberSince">{{ $t('dashboard.member.form.memberSinceTo') }}</label>
              <moment-date-picker v-model="filter.memberSinceTo" :required="false"></moment-date-picker>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-2"> 
              <label for="memberSince">{{ $t('dashboard.member.form.membershipCancellationDateFrom') }}</label>
              <moment-date-picker v-model="filter.membershipCancellationDateFrom" :required="false"></moment-date-picker>
          </div>
          <div class="form-group col-md-2"> 
              <label for="memberSince">{{ $t('dashboard.member.form.membershipCancellationDateTo') }}</label>
              <moment-date-picker v-model="filter.membershipCancellationDateTo" :required="false"></moment-date-picker>
          </div>
          
          <div class="form-group col-md-2"> 
              <label for="memberSince">{{ $t('dashboard.member.form.investmentDateFrom') }}</label>
              <moment-date-picker v-model="filter.investmentDateFrom" :required="false"></moment-date-picker>
          </div>
          <div class="form-group col-md-2"> 
              <label for="memberSince">{{ $t('dashboard.member.form.investmentDateTo') }}</label>
              <moment-date-picker v-model="filter.investmentDateTo" :required="false"></moment-date-picker>
          </div>

          <div class="form-group col-md-4">
            <label for="educationInput">{{ $t('member.form.education') }}</label>
            <multiselect v-model="filter.education" track-by="item1" label="item2"
              :options="educationLevels" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('member.form.education')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>       
          </div>

        </div>

      </div>
    </div>

    <div class="row" v-if="data.length == 0">
      
      <div class="col-xl-12 col-sm-6 mb-4" >
        <div :class="'card text-white o-hidden bg-secondary h-100'">
          <div class="card-body">
            <div class="card-body-icon">
              <i class="fa fa-spinner"></i>
            </div>
            <div class="mr-5">{{ $t("loading")}}</div>
          </div>
        </div>
      </div>
    
    </div>

    <div v-if="data.length != 0">
      <div class="row" >
        <div class="col-md-3" >
          <div class="row">
            <div class="col-sm-12 mb-3" >
              <div class="card text-white o-hidden h-100 bg-primary">
                <div class="card-body">
                  <div class="card-body-icon">
                    <i class="fa fa-fw fa-user-circle-o"></i>
                  </div>
                  <div class="mr-5">{{ filteredData.length }} {{ $t('menu.members') }}</div>
                </div>
                <ul class="list-group list-group-flush text-dark">
                  <li class="list-group-item"> {{ $t("dashboard.member.retention") }} 
                    <span class="pull-right"><strong>{{ retention }} %</strong></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
          <div class="row">
            <div class="col-sm-12 mb-3" >
              <div class="card text-white o-hidden h-100 bg-primary">
                
                 <div class="card-body">
                  <div class="card-body-icon">
                    <i class="fa fa-fw fa-user-circle-o"></i>
                  </div>
                  <div class="mr-5">{{ $t("dashboard.mean") }}</div>
                </div>
                
                <ul class="list-group list-group-flush text-dark">
                  <li class="list-group-item"> {{ $t("dashboard.member.age") }} 
                    <span class="pull-right"><strong>{{ meanAge }}</strong></span>
                  </li>
                  <li class="list-group-item"> {{ $t("dashboard.member.memberSince") }}  
                    <span class="pull-right"><strong>{{ meanMemberSince }}</strong></span>
                  </li>
                  <li class="list-group-item"> {{ $t("dashboard.member.education") }}
                    <span class="pull-right"><strong>{{ meanEducation }}</strong></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 mb-3" >
              <div class="card text-white o-hidden h-100 bg-success">
                <div class="card-body">
                  <div class="card-body-icon">
                    <i class="fa fa-fw fa-money"></i>
                  </div>
                  <div class="mr-5">{{ $t("dashboard.member.investiementTitle") }}</div>
                </div>
                 <ul class="list-group list-group-flush text-dark">
                  <li class="list-group-item">{{ $t('dashboard.member.totalInvested') }} 
                    <span class="pull-right"><strong>{{ totalInvested | moneyFormat }}</strong></span>
                  </li>
                  <li class="list-group-item">{{ $t('dashboard.member.qttInvested') }} 
                    <span class="pull-right"><strong>{{ qttInvested }}</strong></span>
                  </li>
                  <li class="list-group-item">{{ $t('dashboard.member.qttInvestedLead') }} 
                    <span class="pull-right"><strong>{{ qttInvestedLead }}</strong></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>

        <div class="col-md-9"  >
          
          <div class="row">
            
            <div class="col-md-6"  >

              <div class="card mb-3" v-if="sexData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.member.sexVisualisation") }} </div>
                  <pie-chart :chart-data="sexData.data" :options="sexData.options"></pie-chart>
              </div>

            </div>

            <div class="col-md-6" >
              <div class="card mb-3"  v-if="educationData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.member.educationVisualisation") }} </div>
                  <pie-chart :chart-data="educationData.data" :options="educationData.options"></pie-chart>
              </div>

            </div>

            <div class="col-md-12">

              <div class="card mb-3"  v-if="regionData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.member.regionVisualisation") }}</div>
                  <bar-chart :chart-data="regionData.data" :options="regionData.options"></bar-chart>
              </div>
          
            </div>

          </div>
        
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import {
  MemberServiceClient,
  ProjectServiceClient,
  InvestmentServiceClient,
  ExitServiceClient,
  AddressServiceClient,
  PersonServiceClient,
  RoleServiceClient,
} from '../../shared/service-clients/service-clients'
import DashboardMixin from '../../shared/Mixin/DashboardMixin'

export default {
  name: 'MemberDashboard',
  mixins: [DashboardMixin],
  data() {
    return {
      data: [],
      regions: [],
      sexes: [],
      memberTypes: [],
      memberStatus: [],
      educationLevels: [],
      filter: {
        sex: [],
        status: [],
        region: [],
        type: [],
        education: [],
        memberSinceFrom: null,
        memberSinceTo: null,
        membershipCancellationDateFrom: null,
        membershipCancellationDate: null,
        investmentDateFrom: null,
        investmentDateTo: null,
        dateFrom: moment().add('years', -1),
        dateTo: moment(),
      },
    }
  },
  computed: {
    retention: function() {
      let actifs = _.filter(this.filteredData, f => f.status == 2).length
      let inactifs = _.filter(this.filteredData, f => f.status == 3).length

      return ((actifs - inactifs) / actifs * 100).toFixed(2)
    },
    sexData: function() {
      return this.getChartData('sexText')
    },
    regionData: function() {
      return this.getChartData('regionText')
    },
    educationData: function() {
      return this.getChartData('educationText')
    },
    filteredData: function() {
      let filtered = this.data

      filtered = this.filterPropertyByList(filtered, this.filter.sex, 'sex')
      filtered = this.filterPropertyByList(filtered, this.filter.status, 'status')
      filtered = this.filterPropertyByList(filtered, this.filter.region, 'region')
      filtered = this.filterPropertyByList(filtered, this.filter.type, 'type')
      filtered = this.filterPropertyByList(filtered, this.filter.education, 'education')

      if (this.filter.memberSinceFrom != null) {
        filtered = _.filter(filtered, x => x.memberSince != null && moment(x.memberSince).isAfter(this.filter.memberSinceFrom))
      }
      if (this.filter.memberSinceTo != null) {
        filtered = _.filter(filtered, x => x.memberSince != null && moment(x.memberSince).isBefore(this.filter.memberSinceTo))
      }
      if (this.filter.membershipCancellationDateFrom != null) {
        filtered = _.filter(
          filtered,
          x =>
            x.membershipCancellationDate != null && moment(x.membershipCancellationDate).isAfter(this.filter.membershipCancellationDateFrom)
        )
      }
      if (this.filter.membershipCancellationDateTo != null) {
        filtered = _.filter(
          filtered,
          x =>
            x.membershipCancellationDate != null && moment(x.membershipCancellationDate).isBefore(this.filter.membershipCancellationDateTo)
        )
      }
      if (this.filter.investmentDateFrom != null) {
        filtered = _.filter(filtered, x => _.some(x.investiments, s => moment(s.date).isAfter(this.filter.investmentDateFrom)))
      }
      if (this.filter.investmentDateTo != null) {
        filtered = _.filter(filtered, x => _.some(x.investiments, s => moment(x.date).isBefore(this.filter.investmentDateTo)))
      }

      if (this.filter.dateFrom != null) {
        filtered = _.filter(
          filtered,
          x => x.status == 2 || (x.status == 3 && moment(x.membershipCancellationDate).isAfter(this.filter.dateFrom))
        )
      }
      if (this.filter.dateTo != null) {
        filtered = _.filter(
          filtered,
          x => x.status == 2 || (x.status == 3 && moment(x.membershipCancellationDate).isBefore(this.filter.dateTo))
        )
      }

      return filtered
    },
    totalInvested: function() {
      return _.chain(this.filteredData)
        .flatMap(f => f.investiments)
        .map('value')
        .sum()
        .value()
    },
    qttInvested: function() {
      return _.chain(this.filteredData)
        .flatMap(f => f.investiments)
        .groupBy('investmentId')
        .map(m => m)
        .value().length
    },
    qttInvestedLead: function() {
      return _.chain(this.filteredData)
        .flatMap(f => f.investiments)
        .filter(f => f.lead)
        .value().length
    },
    meanAge: function() {
      if (this.filteredData.length == 0) return 0

      let age = _.chain(this.filteredData)
        .filter(f => f.birthdate != null)
        .meanBy(m => moment().diff(m.birthdate, 'years'))
        .value()
      return age != null && age != NaN ? Math.round(age) : 0
    },
    meanEducation: function() {
      if (this.filteredData.length == 0) return this.educationLevels[0].item2

      let education = _.chain(this.filteredData)
        .meanBy(m => m.education)
        .value()

      if (education != null && education != NaN) return _.find(this.educationLevels, f => f.item1 == Math.round(education)).item2
      else return this.educationLevels[0].item2
    },
    meanMemberSince: function() {
      if (this.filteredData.length == 0) return 0

      let member = _.chain(this.filteredData)
        .filter(f => f.memberSince != null)
        .meanBy(m => moment().diff(m.memberSince, 'years'))
        .value()

      return member != null && member != NaN ? Math.round(member) : 0
    },
  },
  methods: {
    fetchData: function() {
      let self = this
      // Workaround for the first time hit bug
      // TODO : Essayer de comprends qqs se passe...
      let pingService = ServiceFactory.create(RoleServiceClient)
      pingService.getAll(0, 1).then(rest => {
        let memberService = ServiceFactory.create(MemberServiceClient)
        let addressService = ServiceFactory.create(AddressServiceClient)
        let personService = ServiceFactory.create(PersonServiceClient)

        self.getMemberData(memberService)
        self.getFilterData(memberService, addressService, personService)
      })
    },
    getFilterData: function(memberService, addressService, personService) {
      let self = this

      addressService.getRegions().then(res => {
        self.regions = res
      })
      personService.getSexes().then(res => {
        self.sexes = res
      })
      memberService.getStatus().then(res => {
        self.memberStatus = _.filter(res, f => f.key != 1 && f.key != 5 && f.key != 6)
      })
      memberService.getTypes().then(res => {
        self.memberTypes = _.filter(res, f => f.key != 2)
      })
      personService.getEducations().then(res => {
        self.educationLevels = res
      })
    },
    getMemberData: function(service) {
      let self = this
      service
        .getDashboardData()
        .then(res => {
          self.data = res
          self.filterVisible = true
        })
        .catch(err => {
          console.log(err)
        })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Member.vue